import {
  deserializeCreationOptions,
  deserializeRequestOptions,
  type PublicKeyCredentialCreationOptionsJSON,
  type PublicKeyCredentialRequestOptionsJSON,
} from '@modules/passkey/helpers/webauthn-serializer.helper';

export interface PasskeyOptionsJsonEnvelope {
  publicKey: PublicKeyCredentialCreationOptionsJSON | PublicKeyCredentialRequestOptionsJSON;
}

export const parseOptionsJsonEnvelope = (optionsJson: string): PasskeyOptionsJsonEnvelope => {
  const parsed = JSON.parse(optionsJson) as Partial<PasskeyOptionsJsonEnvelope>;

  if (!parsed.publicKey || typeof parsed.publicKey !== 'object') {
    throw new Error('Invalid optionsJson: missing publicKey');
  }

  return { publicKey: parsed.publicKey };
};

export const parseCreationOptionsFromOptionsJson = (optionsJson: string): PublicKeyCredentialCreationOptions => {
  const { publicKey } = parseOptionsJsonEnvelope(optionsJson);

  if (
    typeof PublicKeyCredential !== 'undefined' &&
    'parseCreationOptionsFromJSON' in PublicKeyCredential &&
    typeof PublicKeyCredential.parseCreationOptionsFromJSON === 'function'
  ) {
    return PublicKeyCredential.parseCreationOptionsFromJSON(
      publicKey as Parameters<typeof PublicKeyCredential.parseCreationOptionsFromJSON>[0],
    );
  }

  return deserializeCreationOptions(publicKey as PublicKeyCredentialCreationOptionsJSON);
};

export const parseRequestOptionsFromOptionsJson = (optionsJson: string): PublicKeyCredentialRequestOptions => {
  const { publicKey } = parseOptionsJsonEnvelope(optionsJson);

  if (
    typeof PublicKeyCredential !== 'undefined' &&
    'parseRequestOptionsFromJSON' in PublicKeyCredential &&
    typeof PublicKeyCredential.parseRequestOptionsFromJSON === 'function'
  ) {
    return PublicKeyCredential.parseRequestOptionsFromJSON(
      publicKey as Parameters<typeof PublicKeyCredential.parseRequestOptionsFromJSON>[0],
    );
  }

  return deserializeRequestOptions(publicKey as PublicKeyCredentialRequestOptionsJSON);
};
